// Base animated placeholder block
export function Skeleton({ className = '' }) {
  return <div className={`bg-gray-200 animate-pulse rounded-lg ${className}`} />;
}

// Matches the stats card shape
export function SkeletonCard() {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-5 animate-pulse">
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <Skeleton className="h-3 w-28" />
          <Skeleton className="h-8 w-16" />
          <Skeleton className="h-3 w-24" />
        </div>
        <Skeleton className="h-12 w-12 rounded-2xl" />
      </div>
    </div>
  );
}

// Matches a table row
export function SkeletonRow({ cols = 6 }) {
  const widths = ['w-8 mr-2', 'w-32', 'w-40', 'w-20', 'w-24', 'w-16'];
  return (
    <tr className="animate-pulse border-b border-gray-50">
      {Array.from({ length: cols }).map((_, i) => (
        <td key={i} className="px-4 py-3.5">
          <Skeleton className={`h-4 ${widths[i] || 'w-20'}`} />
        </td>
      ))}
    </tr>
  );
}

export default Skeleton;
